import React from 'react'

function Help() {
  return <div className="container text-danger m-5 p-4"></div>
}

export default Help
